import React, { useState } from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Field, FieldArray } from "redux-form";
import { toastr } from "react-redux-toastr";
import { Button, Col, Row } from "react-bootstrap";
import { Icon } from "MODULES/shared/components";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import api from "APP_ROOT/api";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import { COMPANY, ID } from "APP_ROOT/constants";

function LineItems({ lineItems }) {
  return (
    <tbody>
      {lineItems.map((item, idx) => {
        const lineItem = lineItems[idx];

        return (
          <tr key={`item-${lineItem.id}`}>
            <td
              className="text-right"
              style={{ verticalAlign: "top", paddingTop: 8, paddingLeft: 10 }}
            >
              {idx + 1}
            </td>
            <td>
              <Row>
                <Col md={12}>
                  <span className="float-left">
                    {lineItem.part.part_number} |&nbsp;
                    {lineItem.part.description} |&nbsp;
                    {INCOMING_LINE_ITEMS.quoteType[lineItem.quote_type].label}
                  </span>
                </Col>
              </Row>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
}

LineItems.propTypes = {
  lineItems: T.instanceOf(Array),
  fields: T.shape({
    map: T.func
  })
};

export function Form({
  close,
  handleSubmit,
  invalid,
  submitting,
  quote,
  modal
}) {
  const [ccContact, setCcContact] = useState(null);

  const searchContacts = email =>
    api.companies.contacts
      .search(quote.getIn([COMPANY, ID]), { filter: email })
      .then(resp => Promise.resolve(resp.data.results));

  return (
    <AppForm handleSubmit={handleSubmit} modal={modal}>
      <AppForm.Body>
        <Field component={FormInput} name="to" label="To:" disabled />
        <Field
          name="cc"
          label="CC:"
          placeholder="Search by Email"
          component={AutoCompleteField}
          search={searchContacts}
          selectedItem={ccContact}
          formatItem={c => c.email}
          onItemSelected={i => i && setCcContact(i)}
        />
        <div>
          <h4>Parts</h4>
          <Row className="row-col-gutters-half">
            <Col md={12}>
              <table className="table table-striped table-numbered margin-bottom-none">
                <FieldArray
                  name="line_items"
                  component={LineItems}
                  lineItems={quote.get("incoming_quote_line_items").toJS()}
                />
              </table>
            </Col>
          </Row>
        </div>
      </AppForm.Body>
      <AppForm.Footer>
        <Button onClick={close}>Cancel</Button>
        <Button
          type="submit"
          bsStyle="primary"
          disabled={invalid || submitting}
        >
          <Icon name="envelope" fixed />
          &nbsp;{submitting ? "Sending..." : "Send RFQ"}
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

Form.propTypes = {
  close: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  invalid: T.bool.isRequired,
  submitting: T.bool.isRequired,
  quote: T.shape({
    get: T.func,
    getIn: T.func
  }),
  modal: T.bool
};

export default connect((state, props) => ({
  initialValues: {
    to: props.quote.getIn(["contact", "email"])
  }
}))(
  form({
    form: "send-incoming-quote",
    onSubmit: async (data, _, props) => {
      await api.incomingQuotes
        .send(props.quote.get("id"), props.values)
        .then(() => {
          props.close();
          toastr.success("Success", "RFQ successfully sent.");
        })
        .catch(() =>
          toastr.error(
            "Error",
            "Could not send quote. Please refresh page and try again."
          )
        );
    }
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/Send/Form.jsx